module.exports = __webpack_public_path__ + "static/img/giss_navy_anomaly_celsius.9c25fac9.jpg";